import React,{useEffect,useState}  from 'react';
import {Container,Header,Segment,Grid,Button} from 'semantic-ui-react'
import {useHistory} from "react-router-dom";
import dienste from './ScanEtti/dienste'
import {Revision} from './config'


const Home=({db})=>
{
    const [deviceName,setDeviceName]=useState('')
    const [devicePrefix,setDevicePrefix]= useState('')
    const history=useHistory()
    const buttonClick=(e,{name})=>
    {
        history.push(name)
    }
    const deviceId=localStorage.getItem('DeviceId')
    useEffect(()=>{
        const getDeviceInfo=async ()=>
        {
            
            try
            {
                const dev= await db.devices.get(deviceId)
                const myDeviceName= dev ? dev.Name : 'noch nicht synchronisiert'
                if(deviceName !== myDeviceName)
                {
                    setDeviceName(myDeviceName)
                }
                if(dev)
                {
                    setDevicePrefix(dev.Prefix)
                }
            }
            catch(e)
            {
                console.log(e)
            }

           
          
        }
        getDeviceInfo()

    },[deviceId, deviceName])

    return(
        <Container>
           
            <Segment>

                <Grid>

                    <Grid.Column width={13} key={'T1'}>
                        <Header as='h2'>{deviceName}  {devicePrefix ? `Prefix:${devicePrefix}` :''} </Header>
                    </Grid.Column>
                    <Grid.Column width={3} key={'T2'}>
                        <Header as='h6'>Version: {Revision}</Header>
                    </Grid.Column>
                    <Grid.Column width={2} key={'B1'}/>
                    <Grid.Column width={4} key={'B2'}>
                        <Button name='/register/paket/Brief/scan' content={dienste.Brief.name} color={dienste.Brief.color} onClick={buttonClick}/>
                    </Grid.Column>
                    <Grid.Column width={4} key={'B3'}/> 
                    <Grid.Column width={6} key={'B4'}>
                        <Button name='/register/paket/Brief2/scan' content={dienste.Brief2.name} color={dienste.Brief2.color} onClick={buttonClick}/>
                    </Grid.Column>
                    <Grid.Column width={2} key={1}/>
                    <Grid.Column width={4} key={2}>
                        <Button name='/register/paket/DHL/scan' content={dienste.DHL.name} color={dienste.DHL.color} onClick={buttonClick}/>
                    </Grid.Column>
                    <Grid.Column width={4} key={3}/>
                    <Grid.Column width={6} key={4}>
                         <Button name='/register/paket/DHLE/scan' content={dienste.DHLE.name} color={dienste.DHLE.color} onClick={buttonClick}/>
                    </Grid.Column>
                
                    <Grid.Column width={2} key={6}/>
                    <Grid.Column width={4} key={7}>
                         <Button name='/register/paket/GLS/scan' content={dienste.GLS.name} color={dienste.GLS.color} onClick={buttonClick}/>
                    </Grid.Column>
                    <Grid.Column width={4} key={8}/>
                    <Grid.Column width={4} key={9}>
                         <Button name='/register/paket/HERMES/scan' content={dienste.HERMES.name}color={dienste.HERMES.color} onClick={buttonClick}/>
                    </Grid.Column>
                    <Grid.Column width={2} key={14}/>
                    <Grid.Column width={2} key={15}/>
                    <Grid.Column width={4} key={16}>
                         <Button name='/register/paket/DPD/scan' content={dienste.DPD.name} color={dienste.DPD.color} onClick={buttonClick}/>
                    </Grid.Column>
                    <Grid.Column width={4} key={17}/>
                    <Grid.Column width={4} key={18}>
                         <Button name='/register/paket/UPS/scan' content={dienste.UPS.name} color={dienste.UPS.color} onClick={buttonClick}/>
                    </Grid.Column>
                    <Grid.Column width={2} key={19}/>
                   


            
                    <Grid.Column width={2} key={20}/>
                    <Grid.Column width={4} key={21}>
                        <Button name='/register/paket/PRIME/scan' content={dienste.PRIME.name} color={dienste.PRIME.color} onClick={buttonClick}/>
                    </Grid.Column>
                    <Grid.Column width={4} key={22}/>
                    <Grid.Column width={4} key={23}>
                        <Button name='/register/paket/Info/scan' content={dienste.Info.name} color={dienste.Info.color} onClick={buttonClick}/>
                    </Grid.Column>
                    <Grid.Column width={2} key={24}/>
                </Grid>
     
            </Segment>


            <Segment>
                <Header as='h2'>Neuer Datensatz</Header>
                <Grid>
                    <Grid.Column width={2} key='N1'/>
                    <Grid.Column width={4} key='N2'>
                        <Button name='/new/paket'  icon='box' content='Paket' onClick={buttonClick}/>
                    </Grid.Column>
                    <Grid.Column width={4} key='N3'/>
                    <Grid.Column width={4} key='N4'>
                        <Button name='/new/kunde' icon='user' content='Kunde' onClick={buttonClick}/>
                    </Grid.Column>
                    <Grid.Column width={2} key={3}/>
                </Grid>
            </Segment>
        </Container>
    )
}
export default Home
